import * as React from 'react'

const urlsToDecorate = [
  'honeygain.com/sdk/',
  'honeygain.com/monetize-app/',
  'honeygain.com/%d0%bc%d0%be%d0%bd%d0%b5%d1%82%d0%b8%d0%b7%d0%b0%d1%86%d0%b8%d1%8f-%d0%b0%d0%bf%d0%bf/',
  'form.typeform.com/to/srwQ9xiq',
]

const queryParams = ['utm_medium', 'utm_source', 'utm_campaign', 'utm_term']

function decorateUrl(urlToDecorate: string) {
  const url = new URL(urlToDecorate)
  const currentParams = new URLSearchParams(window.location.search)

  for (const element of queryParams) {
    if (currentParams.has(element)) {
      url.searchParams.append(element, currentParams.get(element) ?? '')
    }
  }

  return url.toString()
}

function shouldDecorateAnchor(link: HTMLAnchorElement) {
  return urlsToDecorate.some((url) => link.href.indexOf(url) > -1)
}

function getAnchor(target: EventTarget | null) {
  if (target instanceof HTMLAnchorElement) {
    return target
  }

  if (target instanceof HTMLElement) {
    return target.closest('a')
  }

  return null
}

const LinkDecorator = () => {
  React.useEffect(() => {
    if (typeof window === 'undefined') {
      return
    }

    const anchors = document.querySelectorAll('a')

    for (const anchor of anchors) {
      if (shouldDecorateAnchor(anchor)) {
        anchor.href = decorateUrl(anchor.href)
      }
    }

    const handleClick = (event: MouseEvent) => {
      const anchor = getAnchor(event.target)

      if (anchor && shouldDecorateAnchor(anchor)) {
        event.stopPropagation()
        event.preventDefault()
        window.location.href = decorateUrl(anchor.href)
        return
      }
    }

    document.addEventListener('click', handleClick)

    return () => {
      document.removeEventListener('click', handleClick)
    }
  }, [])

  return null
}

export default LinkDecorator
